import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const EstrattiTutti = () => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/customers/estratti/invia-tutti");
      toast.success(data.inviati ? `Estratto conto inviato a ${data.inviati} clienti` : "Nessun cliente con fatture da incassare e email", { duration: 8000 });
      if (data.senza_email.length) toast.warning(`Senza email, non inviato: ${data.senza_email.join(", ")}`, { duration: 12000 });
      if (data.errori.length) toast.error(`Non inviati: ${data.errori.join("; ")}`, { duration: 12000 });
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="outline" className="bg-white" disabled={busy} data-testid="estratti-tutti-button"><Send className="mr-2 h-4 w-4" />{busy ? "Invio…" : "Estratti a tutti"}</Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Inviare l'estratto conto a tutti?</AlertDialogTitle>
          <AlertDialogDescription>Ogni cliente con fatture o rate ancora da incassare riceve via email il suo estratto conto con il PDF. I clienti senza email vengono saltati e te li elenco.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annulla</AlertDialogCancel>
          <AlertDialogAction data-testid="estratti-tutti-confirm" className="bg-sky-600 hover:bg-sky-700" onClick={go}>Invia a tutti</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
